/**
 * @component LoginModuleManage
 * @description Manages the rendering of different authentication-related components based on the current state.
 * This component is responsible for conditionally displaying the appropriate authentication form depending on the active module in the Redux store
 *
 * @returns {JSX.Element} A React Fragment containing the appropriate authentication form component
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { authModulesForms } from '../../../app/store/slices/authDialog';
import ForgotPasswordForm from './ForgotPasswordForm';
import LoginUsingEmaild from './LoginUsingEmaild';
import InvalidLink from './InvalidLink';

function LoginModuleManage() {
    const selector = useSelector((state) => state.authDialog);
    return (
        <React.Fragment>
            {selector.activeAuthModuleForm === authModulesForms.LOGIN_FORM && <LoginUsingEmaild />}
            {selector.activeAuthModuleForm === authModulesForms.FORGOT_PASSWORD_FORM && (
                <ForgotPasswordForm />
            )}
            {selector.activeAuthModuleForm === authModulesForms.INVALID_LINK && <InvalidLink />}
        </React.Fragment>
    );
}

export default LoginModuleManage;
